import GoogleMap from "../utils/map";
import Form from "../modules/form";

const Contacts = {
  init() {
    new Form("#contact-form");
    Contacts.renderMap();
    Contacts.copyProps();
  },

  renderMap() {
    const mapEl = $("#map-wrap");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
      zoom: mapEl.data("zoom"),
    };

    GoogleMap.create(data, mapEl);
  },

  copyProps() {
    //Copy one property to clipboard
    $(".properties-list__item").on("click", function () {
      var oneProperty = $(this)
        .find(".properties-list__item-value span")
        .text()
        .trim();
      copyText(oneProperty);
    });

    //Copy all properties to clipboard
    $(".properties-list__copy-all").on("click", function () {
      var allProperties = "";
      $(".properties-list")
        .find(".properties-list__item-name, .properties-list__item-value span")
        .each(function () {
          allProperties += $(this).text().trim() + " ";
        });
      copyText(allProperties);
    });

    //Copy property URL to clipboard
    $(".properties-list__copy-link").on("click", function () {
      let url = $(this).data("url");
      copyText(url);
    });

    /**
     * Copy text to clipboard
     */
    function copyText(text) {
      const input = document.createElement("textarea");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
  },
};

export default Contacts;
